
 <div class="d-flex flex-column-fluid flex-column card mt-5 mt-lg-0 p-10">
  <a href="#" class="mb-10 text-center">
    <img class="max-h-75px img-fluid" alt="" [attr.src]="logopath" />
  </a>
  <div class="border-top width100p">&nbsp;</div>
  <!--begin::Signin-->


<h3 class=" font-weight-bold ">AGREEMENT ON TERMS AND CONDITIONS OF USE, FORMAL LEGAL DISCLAIMER AND INFORMED CONSENT</h3>

<p>
These terms and conditions of use (“Terms of Use”), stipulated govern your view, access or actions of use of our online interfaces, properties and services (e.g: websites, links, mobile applications, domains, sites, platforms, etc.,) owned and controlled by CureSelect Healthcare LLC / LLP (“CureSelect, “we “ or “Us”), and you (individual or your as the context means and includes)
</p>

<p>
By clicking “Accept” you agree to be legally bound by these terms and conditions of use. On your acceptance it is clearly meant that you have understood in full the rules that govern the operations of these services, products, etc., and give your “INFORMED CONSENT”. If you do not agree in totally to these terms and conditions you are not authorized to view, these websites. And you are promptly to exit the site.
</p>

<p>
Please consult our private practices and privacy policy for our description for a service, website and any other online service that our company operates and the links to the terms collectively called the services.
</p>

<p>
Please review the below carefully before using any of the services or applications and you will have to clearly read and understand the links of the rules that governs the operation of these service products and give informed consent.
</p>

<p>
The link to the board of governors in supersession of the Medical Council of India constitutes the basis of this application service, website products, etc, dictates the telemedicine practices guidelines enabling registered medical practitioners to provide healthcare using telemedicine under what constitutes appendix five of the Indian medical Council professional code etiquette and ethics regulations 2002 as published on 25 March 2020 for more information check IMC guidelines.
</p>

<p>
Services provider offers a technology platform and infrastructure to collect and enable individuals with participating positions to registered and licensed health care practitioners with respective bodies authorized by Ministry of Health and Family Welfare, Government of India, via live streaming of audio video and or telephone and text services like messaging, email, fax etc.
</p>

<p>
By using the CureSelect LLC /LLP, the service we are characterized as an intermediary, under the Indian Information Technology Act, 2000 and IG rules.
</p>

<p>
It is only a means in situations when access or availability to a healthcare professional is not there for what so ever reason.
</p>

<p>
The company does not provide any positions or healthcare providers or services. All providers are independent and are using our services to communicate and interact with you.
Any information or advice received from a provider, comes from the provider and not from the company. Cureselect Healthcare LLC/LLP/ its Licensors & Suppliers shall not be responsible for any breach or deficiency of service.
</p>

<p>
Your interactions with the provider by the service are not intended to take your relationship with regular health care practitioners.
</p>

<p>
The company nor any of its licensors or suppliers or third parties do not promote the services of a provider. Company only offers a link to the services shall not be liable for any professional advice you receive from time to time from the provider via the service nor for any information offered through our services
</p>

<p>
You are in knowledge, the reliance on any provider or information provided by services is solely at your personal risk and you assume full responsibility for the same.
</p>

<p>
The company does not make any representation or warranty about the training or skill of any providers using the services. You are ultimately responsible for choosing your provider on the services, as mandated by rules for using this telemedicine Platform.
</p>

<h4 class=" font-weight-bold ">CONTEXT</h4>

<p>
This is not a substitute for a face-to-face interface with the healthcare provider, physician or registered medical practitioner. It is only an alternate and definitely NOT a substitute for seeking opinion, evaluation or consult. It is used in whatsoever situations and reasons where there is no access or availability to healthcare professional.
</p>

<h4 class=" font-weight-bold ">COMPLEXITY OR EMERGENCIES</h4>
<b>Emergency</b>

<p>
In emergencies an ambulance must be called to the patient’s environment immediately and healthcare practitioner assist can be solicited by the patient or relatives / guardians through the journey up to handing over to a hospital /nursing home /clinic.
</p>

<b>Management Protocol</b>
<p>
It is the discretion of the healthcare provider to exercise in their professional judgement whether consultation is appropriate in a given situation or a “in person” consultation is needed in the interest of the patient.
</p>

<h4 class=" font-weight-bold ">LIMITATIONS</h4>

<p>
The quality, the continuity, instantaneous connect and timeliness can be sacrificed at the altar of limitation of technology and infrastructure like power, Wi-Fi connectivity or internet connectivity, etc at the site of the provider, patient or in between.
</p>

<p>
Typographical or omissional errors or Communicational vacuum between the provider and the patient can be more when it is not face-to-face.
</p>

<p>
The uncertainty of privacy in spite of the best intentions can theoretically be jeopardized
</p>

<h4 class=" font-weight-bold ">INDENTIFICATION - HEALTH CARE PROVIDER - RMP</h4>

<p>
The registered medical practitioners must be enrolled in the State Medical Register of the Indian Medical Register under the Indian Council act 1956.
</p>

<p>
The Ayush practitioners, nurses, physiotherapist, and other health care practitioners must be registered with the respective bodies which are authorized by the Ministry of Health and Family Welfare, Government of India.
</p>

<p>
The doctor’s medical registration number and his Government approved Photo ID preferably an Aadhaar card is to be affixed in his credential page or face sheet.
</p>

<p>
The specialty and the degrees of the doctor or the healthcare provider should be mentioned on the registration page.
</p>

<h4 class=" font-weight-bold ">MODE OF TELEMEDICINE</h4>


<p>
We provide an audio, video, texts, charts, images, messages, emails, fax etc,
limited by distance and appropriateness as defined by the technology available with us and the connectivity in the providers and the patient’s ecosystem.
</p>

<h4 class=" font-weight-bold ">Patient’s identification:</h4>

<p>
A government authorized photo and age ID of the patient is uploaded on the EMR preferably Aadhaar card. Along with the photo and age ID it should also contain email, phone number and address or and any other identification that may be deemed to appropriate including the id of an emergency contact.
</p>

<p>
You have certified that you are in a sound state of mind and have understood the contents and you have entered into a contract and agreement with having understood the full contents and messages below.
</p>

<p>
You acknowledge that your ability to access and use the services is conditioned upon your acceptance and that the provider you access to services or relying upon his credentials in order to interact with you is solely at your discretion.
</p>

<p>
In the event that your supplications are inaccurate, you agree to indemnify the company in all resulting damages, costs or claims.
</p>

<h4 class=" font-weight-bold ">TO AVAIL CONSULATION BY PATIENT</h4>

<p>
An explicit consent of the patient is required to the provider before initiating any consultation after having understood the entire protocol on the advantages and disadvantages of the system.
This may be sent in form of an Email, SMS or an audio message by the patient.
</p>

<h4 class=" font-weight-bold ">PATIENT INFORMATION</h4>

<p>
The patient’s medical history and examination findings and investigations, past records and current or future records are recorded and stored in the health vault (EMR that’s provided). This is shared with the provider to exercise a proper clinical judgment.
</p>

<p>
Whatever additional information or requirements could be called for and ordered by the provider like laboratory/ images/ tests to arrive at an appropriate diagnosis and management.
</p>

<p>
The provider can call for an additional consultant who may be a colleague or a specialist in the field through the platform in consent with the patient to arrive at a more informed diagnosis.
</p>

<p>
The provider at any stage may differ or reschedule or refuse consult if he feels, he cannot be in a position to offer proper opinion because of the lack of face-to-face examination, prescribing medicines by only online consultation is at the professional discretion of the provider.
</p>

<p>
At the same time it entails professional accountability as in traditional consult.
It’s only after the provider has gathered adequate and relevant information about the patient’s condition can arrive at his clinical judgment to prescribe in the best interest of the patient.
</p>

<p>
The drugs should be safe medicine with a low potential for abuse and should be in the list as in the national formulary index and, should be in line with the Indian Medical Council Professional Code and should not contravene the Drugs and Cosmetic Act.
</p>

<p>
Any medicines listed in the schedule X on the drug and cosmetic act and rules of any narcotic and psychotic substance is limited in the narcotic drugs and psychotropic substances act 1985 cannot be prescribed. Prohibited list of medicines with a high potential of abuse should not be prescribed to the patient. Users are not to seek or persuade providers to prescribe restricted drugs or Medical Termination of Pregnancy.
</p>

<p>
The provider shall retain a copy of the prescription that he/ she has given to the patient including the EMR history and record details that has gone through the consult.
</p>

<p>
Maintain digital trail and documentation of the consult including clinical assessment, tests, diagnosis, and management including prescription records as required in a face-to-face consult.
</p>

<h4 class=" font-weight-bold ">CHARGES FOR TELEMEDICINE CONSULTATION</h4>

<p>
Telemedicine contract consultation to be treated the same way as in person consultation from the perspective RMP, they may charge an appropriate fee for telemedicine consultation as provided.
Provide should give receipt invoice of the charges for providing telemedicine-based consultation
</p>

<h4 class=" font-weight-bold ">MEDICAL ETHICS DATA PRIVACY AND CONFIDENTIALITY</h4>

<p>
Principles of medical ethics confidentiality and data privacy as mentioned (above) including professional laws as per IMC ACT shall be binding and must be Upheld and practiced at all times.
</p>

<p>
Additionally for the providers you acknowledge that ability to access a new service condition that all the truthfulness of you being currently registered under the state medical authority and license to practice on date as a registered medical practitioner under the Indian Medical Council Act and the presentation of your specialty is accurate.
</p>

<p>
The company on the representation and the documents furnished by you has accepted this on verification from their side and you shall be solely responsible for any false representation. Further you should uphold all information’s are current and accurate.
</p>


<h4 class=" font-weight-bold ">USE AGE CRITERIA</h4>
<p>
Only users of age 18 and above have right to access the site. Minor may be represented by a parent or a legal guardian on agreeing on the terms of use.
</p>

<h4 class=" font-weight-bold ">THE PATIENT AND PROVIDER</h4>

<p>
None have the right to use or attempt to access or use the services or take any action that could harm us or a third party or interfere with the operation of services or use the services in a manner that violates the law.
</p>

<p>
Transmit message information about the false affiliation or origin of materials.
On enrolment, not to transmit any message or information that is predatory on minor, harassment, threatening or hateful.
</p>

<p>
Violation of system or network security may result in criminal or civil liability.  Misuse of the above will be prosecuted. The service may be terminated without assigning reasons and without notice.
</p>

<p>

We protect privacy laws of confidential medical information that telemedicine and its policies of electronic communication as with any technology device. Healthcare information that may be shared with others including primary healthcare providers for treatment, payment and healthcare operations psychological and behavioural health assessments and they are not shared with unconnected parties. Further understand that the health information to may be shared in circumstances when a valid court order issued for medical records or reported subject suspected abuse neglect or domestic violence preventing or reducing serious threat to anyone’s health or safety.
</p>

<p>

The User hereby agrees to CureSelect Healthcare’s medical team carrying out an audit of his/her consultations on the Consult platform for the purpose of improving treatment quality, user experience, and other related processes. The User acknowledges that the subject matter of audit may include texts, messages, photographs, reports, audio or video recordings or any other materials exchanged between the User and the Practitioner which could inter alia include User's personal information, including sensitive personal information. This personal information will be processed in accordance with CureSelect Healthcare’s Privacy Policy.
</p>

<p>

User shall refrain from raising any personal queries or advice on the Consult platform which are not related to a specific disease / medicine.
</p>

<p>

Users shall not use abusive language on the Consult platform. In the event of an abuse from the User is reported by a Practitioner, CureSelect Healthcare LLC/ LLP, its Licensors, and its suppliers reserves the right to block such Users from the Consult platform.
</p>

<p>

Users may share images or videos of the affected areas of their body parts with the Practitioner only if it is absolutely necessary for diagnosing his/her condition and if he/she is personally comfortable in sharing such images or videos. CureSelect Healthcare LLC/ LLP, its Licensors, and its suppliers shall not be responsible for any such images or videos shared by the Users with the Practitioners. The practitioners shall record an explicit consent from the patient before evaluating such images or videos.
</p>

<p>

Users shall ensure that any interaction/communication with the Practitioners, including sharing images or videos of the body parts, shall be only through the Consult platform. The Users shall not rely on any other external modes of communication for interacting / communicating with the Practitioners.
</p>

<p>

The User shall indemnify and hold harmless CureSelect Healthcare LLC/ LLP, its Licensors, and its suppliers and its affiliates, subsidiaries, directors, officers, employees and agents from and against any and all claims, proceedings, penalties, damages, loss, liability, actions, costs and expenses (including but not limited to court fees and legal expenses) arising due to or in relation to the use of Website by the User, by breach of the Terms or violation of any law, rules or regulations by the User, or due to such other actions, omissions or commissions of the User that gave rise to the claim.
</p>

<p>

CureSelect Healthcare LLC / LLP, its licensors and its suppliers with the fullest extent permitted by law, disclaim all warranties,  either express or implies, statutory or otherwise, make no representations or warranties about the accuracy, reliability, completeness, correctness or timeliness of the content, software, hardware, links or communications provided on or through the use of our website. In no event CureSelect Healthcare LLC / LLP, its licensors or its suppliers or any third parties mentioned on the site be liable for any damages (including, without limitation, incidental and consequential damages, personal injury/ wrongful death, loss profits or damages resulting from lost data or business interruption) resulting from the use of or inability to use the website or its content whether based on warranty, contract, tort or any other legal theory.
</p>

<p>

We may change the terms or modify any feature of the services at any time you accept the terms by using the services and to accept any changes to the terms by country to use the services after we post the services.
</p>

<p>

By clicking accept, you agree to be bound by the terms and conditions of use.
If you do not agree to these terms and conditions you are not authorized to access or use this website or services rendered online.
</p>

<p>

Electronic medical record is created for you and most instances by you to enter, store your personal health information online including medical history social history family history current health conditions symptoms complaints allergies and medications and for your provider to record the results of investigations  and relevant health symptoms, signs, impressions and inferences during the encounters with you in accordance with his or her obligations under the applicable laws of Indian medical council with regard to creating and maintaining your record. Any information provided as part of your video or telephone consultation becomes a part of your EMR.
</p>

<p>

We even facilitate to upload the scan images, lab results, prescriptions and subsequent refills.
All this falls into your electronic medical record.
</p>

<p>

You have agreed to provide accurate current and complete information about yourself for additional information regarding your EMR kindly see our privacy policy. It is your responsibility to confirm any third-party information or information regarding a minor child of whom you are a parent or legal guardian in the family EMR.
</p>

<p>

<h4 class=" font-weight-bold ">THE COMPANY IS NOT RESPONSIBLE FOR MAINTAINING DATA OR ITS LOSS FROM THE USE OF THE SERVICES FOR REASONS BEYOND ITS CONTROL.</h4>


<p>
Your EMR is shared to your physician to use and disclose the information included in your EMR in accordance to the law without limitation obtaining any consent to authorization that may be required for your information to be shared with other healthcare providers.
</p>

<p>

Electronic Medical Record is maintained with the best interest of your health in mind and portability to be effected in your case as it may be required in an emergency on your reference to another doctor.
</p>

<p>

On operational functionality, the company reserves the right and complete discretion with respect to the operation of its services and the company may among other things patrol, suspend or discontinue any functionality or features of the services. We are not responsible for transmission errors or corrections or compromise of information carried over local or interchange telecommunication carriers other than as required by applicable law. The company is not responsible for maintaining information arising from use of the site.
</p>



<h4 class=" font-weight-bold ">LIMITATIONS OF USE</h4>

<p>
You agree that you will not use the site or services in any unlawful way or for any unlawful purpose.
You may not post or transmit materials that contains the information that is threatening, false, abusive, pornographic or promote any virus or other computer programming or code designated, design or intent to damage the download, interfere or interrupt the site on the services.
</p>

<p>

You may not tamper or modify or otherwise cut off the administration security or proper function of the site or the services. You will not use robots or scripts on the site. You will not attempt to reverse engineered assemble, compile, decompile, disassemble, translate on the device or fraud or create for the search from the exit barcode or information received from the site. You agreed to have antivirus and or anti-display software that is set to override the Internet browsers cookie settings.
</p>

<p>
You further agree that any information they provide or use of the site and your use of site or services will not infringe or facilitate, infringement on any copyright, patent, trademark secret, or other proprietary publicly or privately. Including the privacy rights of any parties including a third party.
</p>

<p>

INTELLECTUAL PROPERTY with the exception of your EMR information, the company retains all rights, title and interest in the company, the site, services, any information, product documentation, software or any other matter on the site and any patent, copyright, trade secret, trademark, services or other intellectual property.
</p>

<h4 class=" font-weight-bold ">DISCLAIMER</h4>

<p>
Disclaimer Telemedicine does not replace the existing primary care physician relationship.
</p>

<p>
This cannot ever replace or even substitute the role played by the doctor in his environment that is his clinic, Nursing home or hospital. Telemedicine is a technology platform and infrastructure that connects individuals with participating physicians, licensed therapist and other licensed healthcare practitioners in real time via a light audio video connectivity.
</p>

<p>
This should be considered only as a means to get opinion or advice in the absence/ non-availability of medical help or a second opinion for which you have no means to have access.
</p>

<p>
The providers may refuse to screen the patient for any reason.
</p>

<p>
The providers who we have agreed to provide patient care to the customers on this service would have signed the terms and conditions.
</p>

<p>
The providers at any point of time reserve the right to deny care, apprehending actual or potential miss use of services.
</p>

<p>

By accepting the terms of use, you acknowledge that you understand and agree with the following you understand and accept that you may not get the anticipated benefit from the use of telemedicine and no results can be guaranteed or assured.
</p>

<p>

It is at your sole discretion and judgment that you have determined to use telemedicine services though it may not be appropriate for some or all your treatment needs and accordingly you may select not to use telemedicine services on this platform.
</p>

<h4 class=" font-weight-bold ">TELEMED PROTOCOL</h4>

<b>TELEMEDICINE</b>


<p>
Definition immediate real-time audio - video - text evaluation of a patient by a healthcare provider any time anywhere to everyone in situations of lack of access for any reason in establishing a face-to-face interface between them.
</p>

<p>

Who can provide Tele-Consultation?<br>
Doctor / Registered medical practitioner who is enrolled in the State medical register of the Indian medical register under the Indian medical Council act 1956.
</p>

<p>

The board of governors of medical Council of India , or any other health providers with the permission of their respective governing body nominated by Ministry of Health  and government of India after sharing the authorization/ license from the medical Council of India / any such body mandated by the government of India Ministry of health.
</p>

<p>
The guidelines of the practice will come under the existing provisions of the Indian medical Council act 1956, the Indian medical Council professional contact etiquette and ethics regulations 2002,  drugs and cosmetics act 1945 and rules 1945,  clinical establishment registration and decoration act 2010, information technology act 2000 and information technology reasonable security practices and procedures and sensitive personal data or information rules 2011 primarily governing the practice of medicine information technology.
</p>

<p>

Further the gaps and vacuum in the legislation and the uncertainty of rules cannot be taken lightly by health care providers omissionally or Commissionally.
</p>

<p>
All providers of healthcare chain shall in letter and spirit will adhere and upkeep the values and conduct of this noble profession.
</p>

<p>
After the crisis is over we expect all doctors registered in the platform to go through courses conducted by the Indian medical Council for the practice of telemedicine so that we can achieve the best possible service.
</p>

<p>
Document of electronic health records are requested to be complete as possible so the provider’s assessment makes the best informed decision.
</p>

<p>




<h4 class=" font-weight-bold ">IDENTIFICATION OF THE PROVIDER AND PATIENT:-</h4>
<b>PROVIDER</b>

<p>
1.	Medical registration certificate of the state council or Indian Medical.<br>
2.	Council. Aadhaar or government approved photo ID of the doctor.

</p>

<b>PATIENT</b>


<p>
<b>Patient</b> : Aadhaar or photo ID of the government ( Request only Aadhaar)

</p>

<p>
Guidelines for telemedicine in India only as an alternate means to seek opinion when it is not accessible or in extreme emergency where a face-to-face interface with the healthcare provider can be established

</p>

<h4 class=" font-weight-bold ">IDENTIFICATION OF THE REGISTERED MEDICAL PRACTITIONER</h4>
<p>
The Enrolment with the State medical Council or the Indian medical Council name age address email ID phone number registered ID is mandated.
</p>

<p>

Minors where the patient is unaccompanied by the parent has to be ascertained to be above the age of 16 or in extreme emergency.
</p>

<p>
The registration number shall be recorded and also shall be on prescriptions, website electronic communication and receipts to the patient.
</p>

<p>

Other health care providers and Ayush practitioners, permission and authorization and registration with their governing bodies which are approved by the Ministry of health are mandatory.
</p>

<h4 class=" font-weight-bold ">MODE OF COMMUNICATION</h4>

<p>
Audio Video Text: Text includes chat images messages email fax etc  <br>
Anytime during the consult the practitioner is not able to reach a diagnosis or understand the context as required by the practitioner, he/she is allowed to use their discretion and judgments to say no the consult as it may be possible to arrive at the best possible opinion or judgment.
</p>

<p>
The explicit consent of the patient must be recorded that the patient agrees to avail the consent via telemedicine. And he fully and clearly understands its use and limitations. Further completely understands the limitations of this type of Tele-evaluation.
</p>

<p>
In routine cases the first choice of the first consult should Tele valuation is not the first choice only as alternate. More often as a follow-up consult / opinion/ advise. The patient clearly and comprehensively understands the situation exercises his consent. When the patient doesn’t comprehend or not able to furnish correct or adequate information with a cosult of a patient, and attender may be called to clearly explain the case
</p>


<h4 class=" font-weight-bold ">PRESCRIBING MEDICINES</h4>

<p>
This entails the same professional accountability as in conventional in person consult.

</p>

<p>
The RMP may prescribe only after the RMP satisfied that they have gathered adequate and relevant information about the patient’s condition in full. And the prescription is given in the best interest of the patient.

</p>

<p>
The medication should be only that which is provided in the national formulary index released by the Indian Medical Council. Drugs that can be misused/ abused should not be prescribed nor can the items in the prohibited list be advised.
</p>

<p>

Medicine in the schedule X of drugs and cosmetics act and rules or any narcotics and psychotropic substance list, listed in the narcotic drugs and psychotropic act 85 should not be prescribed.
</p>

<p>

Practitioners should provide e-prescriptions to the Users only via the prescription module. However, when the Practitioner creates an e-prescription, the Practitioner will be required to confirm the e-prescription with their electronic signature explicitly or implicitly by clicking on the signature option made available or any other form or opt-in methods as provided therein. The Practitioner hereby agrees and covenants to be responsible and liable for the content of e-prescription and the authenticity of his signature signed electronically. In addition to any indemnity warranties provided else-where in the Agreement, the Practitioner hereby agrees to hold CureSelect Healthcare LLC/ LLP, its Licensors, and its suppliers, its officers, employees, agents and affiliates harmless from any claims, damages, losses or penalties arising out of any third party claims in connection with the validity of the e-prescription, its content and/or electronic signature.
</p>


<h4 class=" font-weight-bold ">COMMERCIAL TERMS, REFUND AND CANCELLATION POLICY</h4>

<p>
CureSelect Healthcare LLC/ LLP offer’s online mode of payment. You may use internet banking or debit/credit card for making payment for consultation charges. You shall be directed to our trusted payment gateway partners once you proceed to make payment of Service Fees.
</p>

<p>
CureSelect Healthcare LLC/ LLP, its Licensors, and its suppliers shall not be liable in any manner whatsoever, if incorrect or inaccurate credit / debit card details are provided by you for making the payment of consultation fees or you use a credit/ debit card which is not lawfully owned by you or if you permit a third party to use your password or other means to access your account.
</p>

<p>
CureSelect Healthcare LLC/ LLP, its Licensors, and its suppliers shall keep the aforesaid information confidential at all times and shall not utilize and share the same with any of the third parties unless is an authorized third party website and / or required by law regulation or court order.
</p>

<p>
Refund will be made only through the original mode of payment done. All communications with regards to refund should be sent to support@cureselecthealth.com
</p>

<p>
A Refund request endorsed by our terms should be raised within 24 hours of the encounter.
If a consult is not initiated due to a technical or provider’s fault, a fresh consult is allowed without payment or the charges refunded.
</p>

<p>
All refund will be subjected to a transaction charge that will be deducted while making the refund.
In case of patients credit / Debit card or any other payment account has been accidentally overcharged, on intimation of the same by the patient it could be refunded within 15 working days or it could be adjusted in future consultation. For claiming this, the patient should necessarily have the valid invoice so as to claim the refund. On communication with regards to refund should be sent to support@cureselecthealth.com
</p>

<p>
You can cancel to reschedule an appointment with the Specialist or a Family physician, before 24 hours prior to the appointment. You can reschedule the appointment on the next available time slot of the same provider.
</p>

<p>

If the patient terminates the service subscription prior to the end of the relevant billing cycle, the patient shall not be refunded with any payment relevant to such billing cycle.
</p>

<p>
Refunds may be made in case a request is raised by the user by clicking the cancel button in the user dashboard in CureSelect Healthcare website within the stipulated deadline mentioned in the refund & cancellation policy.
</p>

<p>
Refunds will only be made against genuine and trackable cancellation requests generated by you by clicking on the cancellation button provided in CureSelect Healthcare user dashboard in your CureSelect Healthcare account. Refund request against delays, nature of advice obtained, efficacy of treatment, health outcomes of consultation will not be entertained.
</p>

<p>
Refunds may be processed within 15 working days from the receipt of a request from you. All communications with regards to refund should be sent to support@Cureselecthealth.com
</p>

<p>
You have the option to reschedule or cancel a booked Specialist or Family physician appointment, strictly within the stipulated deadlines as mentioned in the refunds and cancellations policy.
CureSelect Healthcare LLC/ LLP, its Licensors, and its supplier’s standard terms for settlement of payments to Practitioners shall apply.
</p>

<p>
All payment to Practitioner shall be subjected to applicable tax deductions / with holdings.
</p>

<p>
CureSelect Healthcare LLC/ LLP, its Licensors, and its suppliers reserve the right to modify / implement a new pricing structure at any time prior to billing you for your initial payment or for future payments.
</p>

<h4 class=" font-weight-bold ">TERMINATION</h4>


<p>
CureSelect Healthcare LLC/ LLP, its Licensors, and its suppliers reserves the right to suspend or terminate services provided through the Website and under this Agreement, with or without notice and to exercise any other remedy available under law, in case of the occurrence of the following events:
Practitioner breaches any terms and conditions of the Agreement or contravenes applicable laws, and/or A third-party reports violation of any of its right as a result of Consult.

</p>

<p class=" font-weight-bold ">
THE ABOVE TERMS AND CONDITIONS CAN BE ALTERED OR CHANGED TOTALLY ANY TIME WITHOUT NOTICE.

</p>



</div>
